export default {"src":"/_next/static/media/banner-alexandra-grey.dc50b6ce.svg","height":48,"width":99,"blurWidth":0,"blurHeight":0};